export default "__VITE_ASSET__BiEhug$i__"